import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "d-flex flex-column align-items-center text-center" }
const _hoisted_2 = {
  key: 0,
  class: "avatar-wrap"
}
const _hoisted_3 = ["src", "alt"]
const _hoisted_4 = { class: "user-name mt-3" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("p", { class: "confirm-text mt-3 pt-2" }, [
  /*#__PURE__*/_createTextVNode(" You will refund all money! "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" Are you sure you want to refund it? ")
], -1)
const _hoisted_6 = { class: "w-100 mt-4 pt-3" }
const _hoisted_7 = { class: "w-100" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AppButton = _resolveComponent("AppButton")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createBlock(_component_Dialog, {
    id: "remove-modal-confirm",
    title: "",
    "use-header": false,
    size: "sm",
    class: "delete-user-dialog",
    opened: _ctx.opened,
    onHide: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('hide')))
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        (_ctx.isShow)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createElementVNode("img", {
                src: _ctx.avatar,
                alt: _ctx.title
              }, null, 8, _hoisted_3)
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("h3", _hoisted_4, _toDisplayString(_ctx.title), 1),
        _hoisted_5,
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_AppButton, {
            size: "xl",
            type: "danger",
            loading: _ctx.loading,
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('confirm', _ctx.data)))
          }, {
            default: _withCtx(() => [
              _createTextVNode(" Yes, Refund ")
            ]),
            _: 1
          }, 8, ["loading"])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createVNode(_component_AppButton, {
            size: "xl",
            type: "default-transparent",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('cancel')))
          }, {
            default: _withCtx(() => [
              _createTextVNode(" Cancel ")
            ]),
            _: 1
          })
        ])
      ])
    ]),
    _: 1
  }, 8, ["opened"]))
}